import { render, staticRenderFns } from "./BeOnABusinessTrip.vue?vue&type=template&id=21c38fec&scoped=true"
import script from "./BeOnABusinessTrip.vue?vue&type=script&lang=js"
export * from "./BeOnABusinessTrip.vue?vue&type=script&lang=js"
import style0 from "./BeOnABusinessTrip.vue?vue&type=style&index=0&id=21c38fec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c38fec",
  null
  
)

export default component.exports